import { defineNuxtPlugin } from 'nuxt/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import firebase from 'firebase/app';
import { useToast } from 'vue-toastification'
import MyToastError from '~/components/MyToastError.vue'
import MyToast from '~/components/MyToast.vue'

export default defineNuxtPlugin(() => {
  const { userCredentials } = useUserCredentials()
  const privateAxios = usePrivateAxiosInstance()

  try {
    const messaging = getMessaging();

    const toast = useToast()
    onMessage(messaging, (payload) => {
      toast({
        component: MyToast,
        props: {
          title: payload.data?.title,
          detail: payload.data?.body,
        },
      })
    });
  } catch (e) {

  }

  const FCMRequestPermission = async (isAlreadyGranted: boolean) => {
    if(!isAlreadyGranted) {
      if (!Notification || !userCredentials.value.isAuthenticated) {
        throw "Включите уведомления в настройках браузера"
      }

      let result = await Notification.requestPermission()
      if (result !== 'granted') {
        throw "Включите уведомления в настройках браузера";
      }
    }

    const firebaseApp = useFirebaseApp()
    let  messaging
    try {
      messaging = getMessaging(firebaseApp)
    } catch (e) {
      throw "Пуш-уведомления не поддерживаются в Вашем браузере или в режиме инкогнито";
    }

    let token = await getToken(messaging)

    let response = await privateAxios.post('user/device-token', { token: token, os: "web", })

    return response.status == 200
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('firebase-messaging-sw.js', {
        scope: '/firebase-cloud-messaging-push-scope',
      })
      .then((reg) => {
        console.log(`Service Worker Registration (Scope: ${reg.scope})`)
      })
      .catch((error) => {
        const msg = `Service Worker Error (${error})`
        console.error(msg)
      })
  }

  return {
    provide: {
      FCMRequestPermission
    },
  }
})
